import { BookIcon } from '@/assets/SVGs/icons/BookIcon';
import { GridIcon } from '@/assets/SVGs/icons/GridIcon';
import { ReportShieldIcon } from '@/assets/SVGs/icons/ReportShieldIcon';
import { SettingsIcon } from '@/assets/SVGs/icons/SettingsIcon';
import { UserIcon } from '@/assets/SVGs/icons/UserIcon';
import { ISidebarProps } from '@/types';
import { BarChart3, Users, BookOpen, Ticket, Tag, Layers } from 'lucide-react';

export const SIDEBAR_LIST: ISidebarProps[] = [
  {
    title: 'Dashboard',
    icon: GridIcon,
    target: '/',
  },
  { title: 'Users', icon: UserIcon, target: '/users' },
  { title: 'Books', icon: BookIcon, target: '/books' },
  {
    title: 'Catalogue',
    icon: Tag as any,
    target: '/catalogue',
    children: [
      { title: 'Categories', icon: Tag as any, target: '/categories' },
      { title: 'Subcategories', icon: Layers as any, target: '/subcategories' },
    ],
  },
  {
    title: 'Tickets',
    icon: ReportShieldIcon,
    target: '/tickets',
  },
  {
    title: 'Analysis',
    icon: BarChart3 as any,
    target: '/analysis',
    children: [
      { title: 'Users', icon: Users as any, target: '/analysis/users' },
      { title: 'Books', icon: BookOpen as any, target: '/analysis/books' },
      { title: 'Tickets', icon: Ticket as any, target: '/analysis/tickets' },
    ],
  },
  { title: 'Settings', icon: SettingsIcon, target: '/settings' },
];
